import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import PageHeader from '../_components/PageHeader'

const useStyles = makeStyles<Theme, PopularColorsProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'PopularColors' }
)

export interface PopularColorsProps {
  classes?: StyleClasses<typeof useStyles>
}

function PopularColors(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <PageHeader
        title={
          <>
            Most Popular
            <br />
            Colors
          </>
        }
        ctaLink="https://www.sherwin-williams.com/en-us/color/color-collections/top-50-colors"
        ctaLabel="View Colors"
        backgroundImage={
          'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/hero-header-background-image.png'
        }
        headerBackgroundColor="#324658"
      />
    </div>
  )
}

export default PopularColors
